import type { GetSoftwareAccountsParams } from './-query/type';

export const ACCOUNT_TAB_FILTER = {
  ACTIVE: 'ACTIVE',
  INVITED: 'INVITED',
  SUSPENDED: 'SUSPENDED',
  ALL: 'ALL',
} as const;

export type AccountTabFilter =
  (typeof ACCOUNT_TAB_FILTER)[keyof typeof ACCOUNT_TAB_FILTER];

export type AccountOrderBy = Exclude<
  GetSoftwareAccountsParams['orderBy'],
  undefined
>;

export const ACCOUNT_ORDER_BY = {
  APP_USER: 'APP_USER',
  APP_USER_ROLE: 'APP_USER_ROLE',
  EMAIL: 'EMAIL',
  EXTERNAL_STATUS: 'EXTERNAL_STATUS',
  INTERNAL_STATUS: 'INTERNAL_STATUS',
  LAST_SIGNED_IN_AT: 'LAST_SIGNED_IN_AT',
} as const satisfies Record<string, AccountOrderBy>;

type ApiActiveStatusFilter = NonNullable<
  GetSoftwareAccountsParams['activeStatus']
>;

// UI 上の「Suspended」タブは内部的には DEACTIVATED ユーザーをフィルタする。
// URL/i18n キーとの後方互換のためタブキーは SUSPENDED のままとし、API 送信時のみ
// DEACTIVATED にマッピングする (DC-6659)。
export const tabToActiveStatusFilter = (
  tab: AccountTabFilter,
): ApiActiveStatusFilter | undefined => {
  switch (tab) {
    case ACCOUNT_TAB_FILTER.ALL:
      return undefined;
    case ACCOUNT_TAB_FILTER.SUSPENDED:
      return 'DEACTIVATED';
    case ACCOUNT_TAB_FILTER.ACTIVE:
    case ACCOUNT_TAB_FILTER.INVITED:
      return tab;
  }
};
